import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Global from '../../../../store/global-selectors';
import messages from '../messages';
import getDisplayInformation from '../../../../components/data-driven-logo/get-display-information';

const DomesticProviderColumn = ({ id: presetGroupId }) => {
  const domesticProviderId = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'providerId',
    }),
  );

  const providerId = Number.parseInt(domesticProviderId, 10);
  const displayInformation = getDisplayInformation({ providerId });
  if (!displayInformation) {
    return '';
  }
  return displayInformation.name;
};

DomesticProviderColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.domesticProviderColumn,
  name: <FormattedMessage {...messages.domesticProviderColumn} />,
  id: 'domesticProvider',
  isSortable: false,
  render: DomesticProviderColumn,
};
